import { deviceDisplayTypes } from 'common/utils/constants';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DeviceHeaderCheckBox } from '../DeviceCheckBox';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import { setDeviceDisplayMode, handleSort } from 'redux/actions';
import DeviceTableHeaderResizeSlider from '../DeviceTableHeaderResizeSlider';

const DeviceTablePodNameAndCodeHeader = ({ forAlarmMap, hasCheckbox, deviceTableSet, devices }) => {
  const pivotTab = useSelector((store) => store.ui.devicesPage.pivotTab);
  const activeTab = useSelector((store) => store.ui.devicesPage.activeTab);
  const displayType = pivotTab?.deviceDisplayMode ?? deviceDisplayTypes.NAME;

  const isDeviceId = displayType === deviceDisplayTypes.ID;
  const dispatch = useDispatch();
  let deviceColHeader = 'Pod Name';

  switch (displayType) {
    case deviceDisplayTypes.NAME:
      deviceColHeader = 'Pod Name';
      break;
    case deviceDisplayTypes.ID:
      deviceColHeader = 'Pod Code';
      break;
    default:
      break;
  }

  return (
    <div className="DeviceTable_Header_OuterDiv" data-tip={deviceColHeader}>
      {!forAlarmMap && (
        <DeviceHeaderCheckBox devices={devices} hasCheckbox={hasCheckbox} deviceTableSet={deviceTableSet} />
      )}
      <div className="idNameSwitcher">
        <SvgAF
          img={isDeviceId ? IconLoader.icon_toggle_id : IconLoader.icon_toggle_name}
          hover={isDeviceId ? IconLoader.icon_toggle_id_hover : IconLoader.icon_toggle_name_hover}
          tooltip={isDeviceId ? 'Toggle to Pod Code' : 'Toggle to Pod Name'}
          onClick={() => {
            dispatch(setDeviceDisplayMode(isDeviceId ? deviceDisplayTypes.NAME : deviceDisplayTypes.ID));
          }}
        />
      </div>
      <IconAndText
        img={IconLoader.icon_table_sort}
        hoverImg={IconLoader.icon_table_sort_hover}
        text={deviceColHeader}
        reverse
        onClick={() => dispatch(handleSort(activeTab, 'deviceTable', `${isDeviceId ? 'podName' : 'podCode'}`))}
      />
      {!forAlarmMap ? <DeviceTableHeaderResizeSlider /> : null}
    </div>
  );
};

export default DeviceTablePodNameAndCodeHeader;
